import React, { useState } from 'react';
import { Button, Spinner } from '@fluentui/react-components';
import { useAuth } from '../context/AuthContext';
import { isMicrosoftSignInConfigured } from '../services/msalConfig';

const Login: React.FC = () => {
  const { loginWithMicrosoft, isLoading } = useAuth();
  const [error, setError] = useState<string>('');

  const handleMicrosoftSignIn = async () => {
    setError('');

    try {
      await loginWithMicrosoft();
    } catch (error: any) {
      if (error?.errorCode === 'interaction_in_progress') {
        setError('Microsoft sign-in is still completing. Wait a moment, then refresh this page and try again.');
        return;
      }
      const apiMessage = typeof error.response?.data === 'string' ? error.response.data : null;
      setError(apiMessage || 'Microsoft sign-in is restricted to linked DevRain company accounts.');
    }
  };

  return (
    <div className="login-container m365-login-container">
      <div className="login-form-section">
        <div className="login-form-wrapper m365-login-card">
          <div className="login-header">
            <img src="/DevRain_logo_color.svg" alt="DevRain Logo" className="login-logo" />
            <div className="m365-login-kicker">Microsoft 365 inspired workspace</div>
            <h2 className="login-title">Welcome back</h2>
            <p className="login-subtitle">Sign in to your account to continue</p>
          </div>

          <div className="login-form m365-login-form">
            {error && (
              <div className="alert alert-danger m365-message" role="alert">
                {error}
              </div>
            )}

            {isMicrosoftSignInConfigured && (
              <Button
                appearance="primary"
                size="large"
                className="login-button m365-primary-action"
                type="button"
                onClick={handleMicrosoftSignIn}
                disabled={isLoading}
                icon={isLoading ? <Spinner size="tiny" /> : undefined}
              >
                Sign in with Microsoft
              </Button>
            )}
          </div>
        </div>
      </div>

      <div className="login-image-section">
        <img src="/account.jpg" className="login-background-image" alt="Login Background" />
        <div className="login-image-overlay m365-login-overlay">
          <h3 className="image-overlay-title">Manage your projects with ease</h3>
          <p className="image-overlay-subtitle">Stay organized and track your development workflow efficiently</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
